import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

class PostTabsForm extends FormBase {
    public getTabs(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, `[role="tab"][data-role="${Roles.POST_TAB}"]`, HTMLElement);
    }

    public getPanels(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, `[role="tabpanel"][data-role="${Roles.POST_PANEL}"]`, HTMLElement);
    }

    public getTargetPanel(root: ParentNode, targetKey: string): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_PANEL}"][data-panel="${targetKey}"]`, HTMLElement);
    }
}

const postTabsForm = new PostTabsForm();

export { PostTabsForm, postTabsForm };
